module.exports = __webpack_public_path__ + "img/s2P33.62bbd263.png";